/* ==========================================================================
   Alorah 2.0 — JavaScript común. Sin librerías.
   · Carrito lateral: se refresca solo cuando CUALQUIERA toca el carrito
     (nuestro botón, Kaching, otra app), con el Section Rendering de Shopify.
   · Ficha: añadir sin recargar, sin duplicar cuando Kaching ya añadió.
   · Cabecera: menú del móvil, sombra al bajar, icono del carrito.
   · alorahIrAComprar(i): baja a la compra y marca el pack i de Kaching
     (en el advertorial, sin compra en la página, lleva a la ficha con su ?pack).
   · ?pack=N en la ficha: comprueba el pack que dejó elegido main-product y baja a la compra.
   ========================================================================== */
(function () {
  'use strict';

  var A = window.alorah || (window.alorah = {});
  var R = A.rutas || {};
  var RAIZ = (R.raiz || '/').replace(/\/?$/, '/');
  var ANADIR = (R.anadir || '/cart/add') + '.js';
  var CAMBIAR = (R.cambiar || '/cart/change') + '.js';
  var ACTUALIZAR = (R.actualizar || '/cart/update') + '.js';
  /* siempre window.fetch: si una app lo envuelve (Kaching), nuestras llamadas pasan por ella;
     la cabecera X-Alorah evita que nos avisemos a nosotros mismos */
  function fetchNativo(u, o) { return window.fetch(u, o); }
  /* La ruta de esta página, para pedir o mandar la sección del carrito. Nunca la de la barra de direcciones
     tal cual: en «//otro-dominio/» (un 404 que también pinta el tema) empieza por dos barras, y un fetch con
     ella es una URL relativa de protocolo: saldría a ESE dominio y su respuesta se pintaría con innerHTML.
     Aquí las barras (y contrabarras) del principio se quedan en una: la petición vuelve siempre a este sitio. */
  function rutaPagina() {
    return '/' + String(location.pathname || '').replace(/^[\/\\]+/, '');
  }
  /* Segunda cerradura: la sección que se va a pintar solo se acepta si la respuesta viene de este mismo sitio.
     Una respuesta sin «url» (la que fabrica una app que envuelve fetch, como Kaching) no se puede comprobar
     y pasa: la petición ya salió a una ruta fija, o saneada, de este sitio. */
  function delSitio(r) {
    var u = r && r.url, aqui = location.origin || (location.protocol + '//' + location.host);
    return !u || String(u).indexOf(aqui + '/') === 0;
  }

  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------------- dinero ---------------- */
  function miles(txt, sepM, sepD) {
    var p = txt.split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, sepM);
    return p.length > 1 ? p[0] + sepD + p[1] : p[0];
  }
  function dinero(cent) {
    var n = (cent || 0) / 100, dos = n.toFixed(2), cero = Math.round(n).toString();
    return String(A.dinero || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, miles(cero, '.', ''))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, miles(dos, '.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, miles(cero, ',', ''))
      .replace(/\{\{\s*amount\s*\}\}/g, miles(dos, ',', '.'));
  }
  A.dineroFmt = dinero;

  /* ---------------- fecha de entrega (días hábiles, de lunes a viernes) ---------------- */
  var DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  var MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  function sumaHabiles(n) {
    var d = new Date(), k = 0;
    while (k < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) k++; }
    return d;
  }
  function fecha(d) { return DIAS[d.getDay()] + ' ' + d.getDate() + ' de ' + MESES[d.getMonth()]; }
  function pintaEntrega(ctx) {
    var e = A.entrega || {};
    if (!e.max) return;
    var txt = esc(e.txt || 'Recíbelo entre el [desde] y el [hasta]')
      .replace('[desde]', '<b>' + fecha(sumaHabiles(e.min || 1)) + '</b>')
      .replace('[hasta]', '<b>' + fecha(sumaHabiles(e.max)) + '</b>');
    qsa('[data-entrega]', ctx).forEach(function (el) { el.innerHTML = txt; el.hidden = false; });
  }

  /* ---------------- packs de Kaching: los recordamos para el carrito ----------------
     En la ficha, Kaching deja su configuración en
     <script class="kaching-bundles-deal-block-settings" data-product-id="…">.
     Guardamos los tramos (unidades → precio) por producto en la sesión, y el
     carrito los usa para ofrecer «súbete al pack siguiente por solo $X más».
     También guardamos lo que Kaching necesita para meter el pack como él lo hace
     (código del bloque, versión, id del tramo y sus regalos, incluidos los
     «regalos progresivos» que se desbloquean a partir de cierto tramo): así, al
     subir de pack desde el carrito, llegan también los regalos del tramo nuevo. */
  function variantesKaching() {
    /* producto → primera variante disponible, sacado de los datos que pinta Kaching */
    var mapa = {};
    var mete = function (p) {
      if (!p || !p.id || mapa[p.id]) return;
      var vs = p.variants || [], v = null;
      for (var i = 0; i < vs.length; i++) { if (vs[i].availableForSale !== false) { v = vs[i]; break; } }
      if (!v && vs.length) v = vs[0];
      if (v) mapa[p.id] = v.id;
    };
    qsa('kaching-bundles-block[other-products]').forEach(function (b) {
      try { (JSON.parse(b.getAttribute('other-products')) || []).forEach(mete); } catch (e) {}
    });
    qsa('script.kaching-bundles-product').forEach(function (s) {
      try { mete(JSON.parse(s.textContent || '{}')); } catch (e) {}
    });
    return mapa;
  }
  function idDeGid(gid) { var m = String(gid || '').match(/(\d+)\s*$/); return m ? parseInt(m[1], 10) : null; }
  /* Kaching pinta en la ficha TODOS los packs activos del producto, también los de otros mercados
     (p. ej. el de México y el de Estados Unidos). Nos quedamos con el del mercado de la visita:
     primero el que nombra este mercado; si no hay, el general que no lo excluya. Sin esto, el
     último pack de la página pisaba al bueno y el carrito de México leía los precios en dólares. */
  function packsDelMercado() {
    var mercado = window.alorah && window.alorah.mercado != null ? String(window.alorah.mercado) : null;
    var porProducto = {};
    qsa('script.kaching-bundles-deal-block-settings').forEach(function (s) {
      try {
        var cfg = JSON.parse(s.textContent || '{}');
        var pid = s.getAttribute('data-product-id');
        var peso = 0;
        if (cfg.marketId != null) {
          if (mercado === null || String(cfg.marketId) !== mercado) return;
          peso = 2;
        } else {
          var fuera = (cfg.excludedMarketIds || []).map(String);
          if (mercado !== null && fuera.indexOf(mercado) !== -1) return;
          peso = 1;
        }
        if (!porProducto[pid] || peso > porProducto[pid].peso) porProducto[pid] = { cfg: cfg, pid: pid, peso: peso };
      } catch (e) {}
    });
    return Object.keys(porProducto).map(function (k) { return porProducto[k]; });
  }
  function recuerdaTramos() {
    var variantes = null;
    packsDelMercado().forEach(function (pack) {
      try {
        var cfg = pack.cfg;
        var pid = pack.pid;
        var unit = window.alorahProducto && String(window.alorahProducto.id) === String(pid) ? window.alorahProducto.precio : null;
        if (!variantes) variantes = variantesKaching();
        var progresivos = (cfg.progressiveGiftsEnabled && cfg.progressiveGifts && cfg.progressiveGifts.gifts) || [];
        var regalo = function (g) {
          if (!g || g.giftType !== 'product') return null;
          var variante = (g.variantGIDs && g.variantGIDs.length) ? idDeGid(g.variantGIDs[0]) : variantes[idDeGid(g.productGID)];
          /* solo: regalo que Kaching da únicamente con suscripción */
          return variante ? { gift: g.id, variante: variante, cantidad: parseInt(g.quantity, 10) || 1, solo: !!g.applyOnlyForSubscriptions } : null;
        };
        var tramos = (cfg.dealBars || []).map(function (b, n) {
          var q = parseInt(b.quantity, 10) || 1, v = parseFloat(b.discountValue) || 0, precio = null;
          if (b.discountType === 'specific') precio = Math.round(v * 100);
          else if (b.discountType === 'percentage' && unit) precio = Math.round(unit * q * (1 - v / 100));
          else if ((b.discountType === 'fixed' || b.discountType === 'amount') && unit) precio = Math.round(unit * q - v * 100);
          else if (b.discountType === 'default' && unit) precio = unit * q;
          /* regalos del tramo + progresivos desbloqueados en este tramo (unlockAtBar cuenta desde 1) */
          var regalos = (b.freeGifts || []).map(regalo);
          progresivos.forEach(function (g) {
            var desde = parseInt(g.unlockAtBar, 10) || 0;
            if (desde && (g.unlockAtBarOnly ? n + 1 === desde : n + 1 >= desde)) regalos.push(regalo(g));
          });
          return {
            q: q, precio: precio, titulo: b.title || '', id: b.id,
            deal: cfg.nanoId || '', ver: cfg.versionId || '',
            /* como Kaching en la ficha: «sellingPlan» solo viaja en los tramos de precio fijo («specific»)
               y «market» solo si el pack es de un mercado concreto */
            fijo: b.discountType === 'specific', mercado: cfg.marketId || null,
            regalos: regalos.filter(Boolean)
          };
        }).filter(function (t) { return t.precio != null; }).sort(function (a, b) { return a.q - b.q; });
        if (tramos.length) sessionStorage.setItem('alorah_tramos_' + pid, JSON.stringify(tramos));
      } catch (e) { /* sin sesión o JSON raro: el carrito no ofrece subir de pack */ }
    });
  }
  /* lo guardado en la sesión lo puede haber escrito cualquier script de este sitio: solo valen los tramos con la forma
     que guarda recuerdaTramos (unidades y precio como números). Esos números acaban en el HTML del hueco y en el carrito */
  function tramosDe(pid) {
    try {
      var t = JSON.parse(sessionStorage.getItem('alorah_tramos_' + pid) || 'null');
      if (!Array.isArray(t)) return null;
      return t.filter(function (x) {
        return !!x && typeof x.q === 'number' && typeof x.precio === 'number' && (x.regalos == null || Array.isArray(x.regalos));
      });
    } catch (e) { return null; }
  }

  /* ---------------- subir de pack: deshacer y precio con suscripción ----------------
     Al subir de pack desde el carrito se apunta en la sesión, por producto, de dónde venía la
     clienta: { q: unidades de antes, n: unidades de ahora, g: grupo del pack nuevo }. Con eso el
     carrito pinta «✓ Ahora llevas N unidades» + «Deshacer» en ese pack. Tras deshacer se apunta
     { no: grupo del pack devuelto }: a ese pack ya no se le ofrece subir (parecería un bucle).
     Sin sesión no se apunta nada: no hay «Deshacer» y todo sigue como antes. */
  function vueltaDe(pid) {
    try { return JSON.parse(sessionStorage.getItem('alorah_vuelta_' + pid) || 'null'); } catch (e) { return null; }
  }
  function apuntaVuelta(pid, dato) {
    try { sessionStorage.setItem('alorah_vuelta_' + pid, JSON.stringify(dato)); } catch (e) { /* sin sesión: no se ofrece deshacer */ }
  }
  /* la suscripción de una línea, en la forma que Kaching guarda en su propiedad:
     { id, priceAdjustment: { type, value } }. La deja marcaPacks en data-plan-kb. */
  function planKaching(linea) {
    try { return JSON.parse(linea.getAttribute('data-plan-kb') || 'null'); } catch (e) { return null; }
  }
  /* lo que Kaching cobra por un tramo en esa línea: su precio y, con suscripción, menos el
     porcentaje del plan ($899 → $764.15 con el 15 %). Si hay plan y no es de porcentaje no se
     sabe lo que se cobrará: null, y el carrito no ofrece subir. */
  function precioTramo(tramo, linea) {
    if (!tramo || tramo.precio == null) return null;
    if (!linea.getAttribute('data-plan')) return tramo.precio;
    if (tramo.fijo === false) return null;   /* tramo que no es de precio fijo + suscripción: Kaching no manda «sellingPlan»; no se ofrece */
    var aj = (planKaching(linea) || {}).priceAdjustment;
    if (!aj || aj.type !== 'percentage') return null;
    return Math.round(tramo.precio * (100 - (parseFloat(aj.value) || 0)) / 100);
  }

  /* ======================================================================
     CARRITO LATERAL
     ====================================================================== */
  var Carrito = {
    abierto: false,
    ultimoFoco: null,

    raiz: function () { return qs('#CarritoLateral'); },

    abrir: function () {
      var r = this.raiz();
      if (!r) { location.href = R.carrito || '/cart'; return; }
      if (this.abierto) return;
      this.abierto = true;
      this.ultimoFoco = document.activeElement;
      r.hidden = false;
      document.documentElement.classList.add('bloqueo');
      requestAnimationFrame(function () { r.classList.add('abierto'); });
      var x = qs('[data-cerrar-carrito]', r);
      setTimeout(function () { if (x) x.focus({ preventScroll: true }); }, 60);
      this.reloj();
    },

    cerrar: function () {
      var r = this.raiz();
      if (!r || !this.abierto) return;
      this.abierto = false;
      r.classList.remove('abierto');
      document.documentElement.classList.remove('bloqueo');
      setTimeout(function () { if (!Carrito.abierto) r.hidden = true; }, 320);
      if (this.ultimoFoco && this.ultimoFoco.focus) this.ultimoFoco.focus({ preventScroll: true });
    },

    /* pinta el HTML que devuelve Shopify para la sección «cart-drawer» */
    pinta: function (html) {
      var r = this.raiz();
      if (!r || !html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var nuevo = qs('[data-carrito-contenido]', tmp), viejo = qs('[data-carrito-contenido]', r);
      if (nuevo && viejo) viejo.replaceWith(nuevo);
      this.despuesDePintar();
    },

    despuesDePintar: function () {
      var r = this.raiz();
      if (!r) return;
      var c = qs('[data-carrito-contenido]', r);
      var n = c ? c.getAttribute('data-cuenta') : null;
      if (n != null) qsa('[data-burbuja-carrito]').forEach(function (b) { b.textContent = n === '0' ? '' : n; });
      /* si en el carrito solo queda la protección de envío, se quita (una vez por línea: sin bucles si falla) */
      var pc = c ? c.getAttribute('data-prot-clave') : '';
      if (n === '0' && pc && this.protQuitada !== pc) { this.protQuitada = pc; this.quita([pc]); return; }
      pintaEntrega(r);
      this.marcaPacks();
      this.reloj();
      document.dispatchEvent(new CustomEvent('alorah:carrito', { detail: { cuenta: n } }));
    },

    refresca: function () {
      var self = this;
      return fetchNativo(rutaPagina() + '?sections=cart-drawer', { headers: { 'X-Alorah': '1' } })
        .then(function (r) {
          if (!delSitio(r)) throw new Error('origen');   /* respuesta de otro dominio: no se pinta */
          return r.json();
        })
        .then(function (j) { self.pinta(j['cart-drawer']); })
        .catch(function () {});
    },

    ocupado: function (si) {
      var c = qs('[data-carrito-contenido]', this.raiz());
      if (c) c.setAttribute('aria-busy', si ? 'true' : 'false');
    },

    aviso: function (txt) {
      var b = qs('[data-carrito-aviso]', this.raiz());
      if (!b) return;
      b.textContent = txt; b.hidden = false;
      setTimeout(function () { b.hidden = true; }, 5000);
    },

    /* POST con JSON; Shopify devuelve el carrito y la sección ya pintada */
    envia: function (url, datos) {
      var self = this;
      datos.sections = 'cart-drawer';
      datos.sections_url = rutaPagina();
      self.ocupado(true);
      return fetchNativo(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Alorah': '1' },
        body: JSON.stringify(datos)
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, j: j, propia: delSitio(r) }; });
      }).then(function (res) {
        if (!res.ok) {
          /* el aviso va después de repintar: pinta() sustituye el nodo donde vive */
          var msg = res.j.description || res.j.message || 'No se pudo actualizar el carrito.';
          return self.refresca().then(function () { self.aviso(msg); });
        }
        /* la sección de la respuesta solo se pinta si viene de este sitio; si no, se pide de nuevo */
        if (res.propia && res.j.sections && res.j.sections['cart-drawer']) self.pinta(res.j.sections['cart-drawer']);
        else return self.refresca();
      }).catch(function () {
        self.aviso('Sin conexión. Vuelve a intentarlo.');
      }).then(function () { self.ocupado(false); });
    },

    cantidad: function (clave, n) { return this.envia(CAMBIAR, { id: clave, quantity: Math.max(0, n) }); },

    quita: function (claves) {
      var upd = {};
      claves.forEach(function (k) { if (k) upd[k] = 0; });
      return this.envia(ACTUALIZAR, { updates: upd });
    },

    anade: function (idVariante, cantidad) {
      return this.envia(ANADIR, { items: [{ id: parseInt(idVariante, 10), quantity: cantidad || 1 }] });
    },

    /* Cambiar un pack por el del tramo de q unidades, como lo haría Kaching desde la ficha.
       Se añade el pack nuevo con sus regalos (mismo «id» de grupo, id del tramo en «bid») y
       después se quita el pack viejo con sus regalos: si añadir falla, la clienta no pierde nada.
       La suscripción viaja dos veces, igual que desde la ficha: «selling_plan» para Shopify y
       «sellingPlan» dentro de la propiedad de Kaching. Lo segundo es lo que lee el descuento de
       Kaching: sin ello cobraba el tramo sin el descuento del plan (6 uds. a $1,199, no a $1,019.15).
       alHecho(grupo) se llama justo antes de repintar, y solo si el cambio entró por este camino.
       Sin los datos de Kaching, o si Shopify rechaza el pack, se cambia la cantidad como antes
       (el precio sale bien, pero sin los regalos del tramo nuevo). Con «estricto» (deshacer) ese
       plan B no vale: el carrito se queda como está y se avisa. */
    cambiaPack: function (li, q, alHecho, estricto) {
      var self = this;
      if (self.subiendo || self.limpiando) return;  /* cerrojo: un segundo Enter no lanza otro cambio, ni se cambia mientras unPack quita un pack viejo */
      var clave = li.getAttribute('data-clave');
      var pid = li.getAttribute('data-producto');
      var t = null, tramos = tramosDe(pid);
      (tramos || []).forEach(function (x) { if (x.q === q) t = x; });
      var variante = parseInt(li.getAttribute('data-variante'), 10);
      var quitarBtn = qs('[data-quitar]', li);
      var viejas = quitarBtn ? quitarBtn.getAttribute('data-quitar').split('|').filter(Boolean) : [clave];
      var avisa = function (txt) { return self.refresca().then(function () { self.aviso(txt); }); };
      var planB = function () {
        if (estricto) return avisa('No se pudo deshacer el cambio: tu carrito sigue como estaba.');
        return self.cantidad(clave, q);
      };
      if (!t || !t.id || !t.deal || !variante) return planB();

      var abc = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-', grupo = '';
      for (var i = 0; i < 4; i++) grupo += abc.charAt(Math.floor(Math.random() * abc.length));
      /* mismas claves y mismo orden que Kaching: deal, pp, main, [market], v, id, bid, [sellingPlan] */
      var kb = { deal: t.deal, pp: parseInt(pid, 10), main: true };
      if (t.mercado) kb.market = t.mercado;
      kb.v = t.ver; kb.id = grupo; kb.bid = t.id;
      var plan = li.getAttribute('data-plan'), planKb = plan ? planKaching(li) : null;
      if (planKb && t.fijo !== false) kb.sellingPlan = planKb;
      var principal = { id: variante, quantity: q, properties: { __kaching_bundles: JSON.stringify(kb) } };
      if (plan) principal.selling_plan = parseInt(plan, 10);
      /* Shopify pone arriba lo último que entra: regalos al revés y el pack al final,
         para que quede como desde la ficha (pack y debajo sus regalos, en su orden) */
      var items = (t.regalos || []).filter(function (g) { return !g.solo || plan; }).map(function (g) {
        return { id: g.variante, quantity: g.cantidad || 1, properties: { __kaching_bundles: JSON.stringify({ id: grupo, deal: t.deal, v: t.ver, gift: g.gift }) } };
      }).reverse().concat([principal]);

      var cabeceras = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Alorah': '1' };
      var carritoJs = function () {
        return fetchNativo((R.carrito || '/cart') + '.js', { headers: { 'Accept': 'application/json', 'X-Alorah': '1' } }).then(function (r) { return r.json(); });
      };
      var esNuevo = function (it) {
        try { return JSON.parse(it.properties.__kaching_bundles).id === grupo; } catch (e) { return false; }
      };
      /* quitar el pack viejo: se comprueba que de verdad se fue y se reintenta una vez */
      var quitaViejas = function (intento) {
        var upd = {};
        viejas.forEach(function (k) { upd[k] = 0; });
        return fetchNativo(ACTUALIZAR, { method: 'POST', headers: cabeceras, body: JSON.stringify({ updates: upd, sections: 'cart-drawer', sections_url: rutaPagina() }) })
          .then(function (r) {
            return r.json().then(function (j) {
              var quedan = (j.items || []).some(function (it) { return viejas.indexOf(it.key) > -1; });
              if (!r.ok || quedan) throw new Error('quitar');
              if (!delSitio(r)) j.sections = null;   /* sección de otro dominio: no se pinta; pintaRespuesta la pide de nuevo */
              return j;
            });
          })
          .catch(function (e) { if (!intento) return quitaViejas(1); throw e; });
      };
      /* el cambio ya está hecho: primero se apunta (alHecho) y luego se repinta, para que el hueco salga ya con su aviso */
      var pintaRespuesta = function (j) {
        if (alHecho) alHecho(grupo);
        if (j && j.sections && j.sections['cart-drawer']) self.pinta(j.sections['cart-drawer']);
        else return self.refresca();
      };

      var paso = 'comprobar';
      self.subiendo = true;
      self.ocupado(true);
      return carritoJs()
        .then(function (cart) {
          /* el carrito de esta pestaña puede estar viejo (otra pestaña ya lo cambió): si el pack no sigue igual, solo se repinta */
          var sigue = cart.items.some(function (it) { return it.key === clave && it.quantity === (parseInt(li.getAttribute('data-cantidad'), 10) || it.quantity); });
          if (!sigue) { paso = 'desfasado'; return self.refresca(); }
          /* restos de un cambio a medias (la red se cortó entre el añadir y el quitar, o la clienta se fue de la página
             en ese momento): si en el carrito hay OTRO pack de este mismo producto, se va con el viejo. Un pack por
             producto, como en unPack: sin esto, volver a tocar «Lo quiero» tras el aviso dejaba dos packs */
          var sobran = Object.create(null);   /* sin prototipo, como los grupos de marcaPacks y unPack: la clave sale de una propiedad de línea */
          cart.items.forEach(function (it) {
            var x = grupoKaching(it);
            if (x && x.kb.main && it.key !== clave && String(x.kb.pp || it.product_id) === String(pid)) sobran[x.g] = true;
          });
          cart.items.forEach(function (it) {
            var x = grupoKaching(it);
            if (x && sobran[x.g] && viejas.indexOf(it.key) === -1) viejas.push(it.key);
          });
          paso = 'anadir';
          return fetchNativo(ANADIR, { method: 'POST', headers: cabeceras, body: JSON.stringify({ items: items }) }).then(function (r) {
            /* un 5xx, un 429 o un 408 es un fallo pasajero, no un rechazo: se trata como un corte (abajo se mira si el
               pack llegó a entrar). Solo un rechazo de verdad (422 sin existencias, 404…) lleva al plan B */
            if (r.status >= 500 || r.status === 429 || r.status === 408) throw new Error('anadir');
            if (!r.ok) { paso = 'rechazado'; return planB(); }   /* Shopify lo rechazó: plan B */
            paso = 'quitar';
            return quitaViejas(0).then(pintaRespuesta);
          });
        })
        .catch(function () {
          if (paso === 'anadir') {
            /* la conexión se cortó sin respuesta: se mira si el pack nuevo llegó a entrar antes de hacer nada */
            return carritoJs().then(function (cart) {
              if (cart.items.some(esNuevo)) { paso = 'quitar'; return quitaViejas(0).then(pintaRespuesta); }
              /* no entró y no fue un rechazo: NO se cambia la cantidad de la línea vieja (ese plan B deja un pack con las
                 unidades de un tramo y la barra de otro, sin los regalos del tramo y sin «Deshacer», por un fallo que se
                 arregla tocando otra vez). El carrito sigue igual y se avisa */
              paso = 'rechazado';
              return avisa(estricto ? 'No se pudo deshacer el cambio: tu carrito sigue como estaba.' : 'No se pudo completar el cambio: tu carrito sigue como estaba. Vuelve a intentarlo.');
            });
          }
          if (paso === 'quitar') {
            /* el pack nuevo entró y el viejo no se pudo quitar. Antes de avisar se mira el carrito:
               · si el viejo ya no está (se perdió la respuesta), el cambio está hecho: se apunta y se repinta;
               · si siguen los dos, se retira el nuevo para dejar el carrito como estaba (si no, quedaban los dos
                 packs y, tras «Deshacer», el enlace seguía a la vista y un segundo toque metía otro pack más). */
            return carritoJs().then(function (cart) {
              if (!cart.items.some(function (it) { return viejas.indexOf(it.key) > -1; })) return pintaRespuesta(null);
              var upd = {};
              cart.items.forEach(function (it) { if (esNuevo(it)) upd[it.key] = 0; });
              return fetchNativo(ACTUALIZAR, { method: 'POST', headers: cabeceras, body: JSON.stringify({ updates: upd }) })
                .then(function (r) {
                  if (!r.ok) throw new Error('retirar');
                  return avisa('No se pudo completar el cambio: tu carrito sigue como estaba. Vuelve a intentarlo.');
                });
            }).catch(function () { return avisa('Revisa tu carrito: no se pudo quitar el pack anterior.'); });
          }
          return avisa('Sin conexión. Vuelve a intentarlo.');
        })
        .catch(function () { return avisa('Revisa tu carrito: no se pudo completar el cambio.'); })
        .then(function () { self.subiendo = false; self.ocupado(false); });
    },

    /* «Lo quiero»: subir al pack siguiente. Se apunta de dónde venía la clienta para poder deshacer
       (solo si el pack nuevo entró entero; si se subió por el plan B, todo sigue como antes).
       «recien» = grupo del pack que acaba de cambiar: ofreceSubir lo gasta al pintarlo por primera vez. */
    subir: function (boton) {
      var self = this;
      /* la misma espera que «Deshacer»: un «Lo quiero» recién nacido justo donde acaba de tocar la clienta no cuenta */
      if (Date.now() < (self.deshacerDesde || 0)) return;
      var li = boton.closest('.linea');
      var q = parseInt(boton.getAttribute('data-cant'), 10);
      if (!li) return this.cantidad(boton.getAttribute('data-subir'), q);
      var pid = li.getAttribute('data-producto');
      var antes = parseInt(li.getAttribute('data-cantidad'), 10) || 0;
      return this.cambiaPack(li, q, function (grupo) {
        self.recien = grupo;
        if (antes) apuntaVuelta(pid, { q: antes, n: q, g: grupo });
      });
    },

    /* «Deshacer»: vuelve al pack de antes con sus regalos y su suscripción (el mismo cambio, al revés).
       Al pack devuelto ya no se le ofrece subir otra vez: ofreceSubir lo reconoce por el grupo apuntado.
       «Deshacer» nace justo donde estaba «Lo quiero»: durante la espera que le pone ofreceSubir al
       pintarlo, un toque no cuenta (el segundo toque de una clienta impaciente no deshace la subida). */
    deshacer: function (boton) {
      var self = this;
      if (Date.now() < (self.deshacerDesde || 0)) return;
      var li = boton.closest('.linea');
      var pid = li ? li.getAttribute('data-producto') : null;
      var v = pid ? vueltaDe(pid) : null;
      if (!v || !v.q || !v.g || v.g !== li.getAttribute('data-grupo')) return this.refresca();
      return this.cambiaPack(li, v.q, function (grupo) { self.recien = grupo; apuntaVuelta(pid, { no: grupo }); }, true);
    },

    /* lo que acaba de pasar, dicho para el lector de pantalla. La región vive fuera de lo que se repinta
       (pinta() cambia entero [data-carrito-contenido], y una región que nace ya con su texto no se lee). */
    voz: function (txt) {
      var r = this.raiz();
      if (!r || !txt) return;
      var v = qs('[data-carrito-voz]', r);
      if (!v) {
        v = document.createElement('p');
        v.className = 'carrito-oculto';
        v.setAttribute('data-carrito-voz', '');
        v.setAttribute('role', 'status');
        r.appendChild(v);
      }
      v.textContent = '';
      setTimeout(function () { v.textContent = txt; }, 80);
    },

    /* Los packs de Kaching se reconocen por la propiedad privada __kaching_bundles.
       Liquid no la ve (es privada), pero /cart.js sí: aquí se marca cada pack para
       quitarle los +/- (bajar de tramo dejaría el regalo sin descuento), para que
       la papelera quite el pack entero con su regalo, y para ofrecer subir de pack. */
    marcaPacks: function () {
      var self = this, r = this.raiz();
      if (!r || !qs('.linea', r)) return;
      window.fetch((R.carrito || '/cart') + '.js', { headers: { 'Accept': 'application/json', 'X-Alorah': '1' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          /* sin prototipo: el «id» de grupo sale de una propiedad de línea, que puede escribir cualquiera que añada al
             carrito. Con {} un grupo llamado «__proto__» o «constructor» tiraba la función entera (ese carrito se
             quedaba sin ofertas, sin «Deshacer» y sin la papelera de grupo) */
          var grupos = Object.create(null);
          cart.items.forEach(function (it) {
            var kb = it.properties && it.properties.__kaching_bundles;
            if (!kb) return;
            try { kb = typeof kb === 'string' ? JSON.parse(kb) : kb; } catch (e) { return; }
            if (!kb || typeof kb !== 'object') return;   /* «null», un número o un texto: no es un pack */
            it.__kb = kb;
            /* el pack y sus regalos comparten «id» (un pack por compra); los datos viejos solo traen «v» */
            var g = kb.id || kb.v;
            if (g) (grupos[g] = grupos[g] || []).push(it.key);
          });
          var cont = qs('[data-carrito-contenido]', r);
          cart.items.forEach(function (it) {
            var kb = it.__kb;
            if (!kb || !kb.main) return;
            var li = qs('.linea[data-clave="' + (window.CSS && CSS.escape ? CSS.escape(it.key) : it.key) + '"]', r);
            if (!li) return;
            li.setAttribute('data-linea-pack', '');
            li.setAttribute('data-producto', kb.pp || it.product_id);
            li.setAttribute('data-cantidad', it.quantity);
            li.setAttribute('data-precio', it.final_line_price);
            li.setAttribute('data-variante', it.variant_id);
            /* suscripción: el id va a Shopify (data-plan) y el «sellingPlan» de Kaching a data-plan-kb.
               Se copia el que puso Kaching en su propiedad; si el pack no lo trae (se subió con la versión
               anterior del carrito), se rehace con el porcentaje del plan que da Shopify. */
            var sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
            if (sp) {
              li.setAttribute('data-plan', sp.id);
              var pk = kb.sellingPlan && String(kb.sellingPlan.id) === String(sp.id) ? kb.sellingPlan : null;
              var aj = (sp.price_adjustments || [])[0];
              if (!pk && aj && aj.value_type === 'percentage') pk = { id: sp.id, priceAdjustment: { type: 'percentage', value: aj.value } };
              if (pk) li.setAttribute('data-plan-kb', JSON.stringify(pk));
            }
            var cant = qs('.linea-cant', li);
            if (cant) cant.outerHTML = '<span class="linea-unidades">' + it.quantity + (it.quantity === 1 ? ' ud.' : ' uds.') + '</span>';
            var quitar = qs('[data-quitar]', li), g = kb.id || kb.v;
            if (quitar && g && grupos[g]) quitar.setAttribute('data-quitar', grupos[g].join('|'));
            if (g) li.setAttribute('data-grupo', g);   /* para reconocer el pack recién subido o devuelto */
            if (!qs('[data-subir-hueco]', li) && cont) {
              var h = document.createElement('div');
              h.className = 'linea-subir'; h.hidden = true;
              h.setAttribute('data-subir-hueco', '');
              h.setAttribute('data-texto', cont.getAttribute('data-subir-txt') || '');
              h.setAttribute('data-boton', cont.getAttribute('data-subir-boton') || '');
              /* compacto: hijo del li, ocupa todo el ancho · clásico: dentro del texto, como antes */
              var info = !li.closest('.carrito--compacto') && qs('.linea-info', li);
              (info || li).appendChild(h);
            }
          });
          self.ofreceSubir();
        }).catch(function () {});
    },

    /* El hueco de cada pack dice una de tres cosas:
       · «✓ Ahora llevas N unidades» + «Deshacer», si la clienta acaba de subir a ese pack;
       · «Vuelves a llevar N unidades», sin botón, si lo deshizo (a ese pack no se le insiste);
       · «Llévate N por solo $X más» + botón, con los tramos que dejó la ficha.
       $X es lo que de verdad se cobra de más: con suscripción, el tramo lleva el descuento del plan.
       El botón admite [mas] y [n] («Subir por [mas]»). */
    ofreceSubir: function () {
      var self = this, r = this.raiz();
      if (!r) return;
      var cont = qs('[data-carrito-contenido]', r), sinCent = !!(cont && cont.hasAttribute('data-sin-centavos'));
      /* textos del editor. Si el atributo no está (sección sin actualizar) vale el de fábrica; vacío = no sale */
      var ajuste = function (nombre, fabrica) {
        var v = cont ? cont.getAttribute(nombre) : null;
        return v == null ? fabrica : v;
      };
      var txtHecho = ajuste('data-subir-hecho', '✓ Ahora llevas [n] unidades');
      /* solo espacios cuenta como vacío: si no, saldría un botón sin nombre pero activo */
      var txtDeshacer = String(ajuste('data-subir-deshacer', 'Deshacer')).replace(/^\s+|\s+$/g, '');
      var txtDeshecho = ajuste('data-subir-deshecho', 'Vuelves a llevar [n] unidades');
      /* [n] y [mas] se cambian TODAS las veces que salgan, como hace Liquid en el carrito de ejemplo del editor, y con
         split/join: así un «$» del precio no se toma por un patrón de replace. Con 1 sola unidad (packs con barra de 1:
         EyeLift, crema, bálsamo), «unidades» pasa a «unidad» */
      var texto = function (plantilla, n, mas, negrita) {
        var a = negrita ? '<b>' : '', z = negrita ? '</b>' : '';
        var t = esc(plantilla);
        if (n === 1) t = t.replace(/\bunidades\b/g, 'unidad');
        return t.split('[n]').join(a + n + z).split('[mas]').join(a + mas + z);
      };
      qsa('[data-linea-pack]', r).forEach(function (linea) {
        var hueco = qs('[data-subir-hueco]', linea);
        if (!hueco) return;
        var pid = linea.getAttribute('data-producto');
        var q = parseInt(linea.getAttribute('data-cantidad'), 10) || 1;
        var ahora = parseInt(linea.getAttribute('data-precio'), 10) || 0;
        var grupo = linea.getAttribute('data-grupo') || '';
        var clave = esc(linea.getAttribute('data-clave'));
        /* primer pintado de este pack tras subir o deshacer: se dice en voz y «Deshacer» estrena su espera */
        var estrena = !!grupo && self.recien === grupo;
        /* la espera vale para lo que nazca en el hueco: «Deshacer» o, si «Deshacer» está vacío en el editor o no se
           pudo apuntar la vuelta, otra vez «Lo quiero» con el tramo siguiente */
        if (estrena) { self.recien = null; self.deshacerDesde = Date.now() + 1500; }
        var escribe = function (clase, html) {
          hueco.className = 'linea-subir' + (clase ? ' ' + clase : '');
          hueco.innerHTML = html;
          hueco.hidden = !html;
          var dicho = estrena && clase && html ? qs('span', hueco) : null;
          if (dicho) self.voz(dicho.textContent);
        };
        var v = grupo ? vueltaDe(pid) : null;
        if (v && v.g === grupo && v.n === q && v.q && txtDeshacer) {
          if (estrena) self.deshacerDesde = Date.now() + 1500;
          escribe('linea-subir--hecho', '<span>' + texto(txtHecho, q, '', true) + '</span>'
            + '<button type="button" class="linea-deshacer" data-deshacer="' + clave + '">' + esc(txtDeshacer) + '</button>');
          return;
        }
        if (v && v.no === grupo) {
          escribe('linea-subir--nota', txtDeshecho ? '<span>' + texto(txtDeshecho, q, '', true) + '</span>' : '');
          return;
        }
        var tramos = tramosDe(pid), sig = null;
        for (var i = 0; tramos && i < tramos.length; i++) { if (tramos[i].q > q) { sig = tramos[i]; break; } }
        var precio = precioTramo(sig, linea);
        if (precio == null || precio <= ahora) { escribe('', ''); return; }
        var txtMas = dinero(precio - ahora);
        if (sinCent) txtMas = txtMas.replace(/[.,]00(?!\d)/, '');
        escribe('', '<span>' + texto(hueco.getAttribute('data-texto') || 'Llévate [n] por solo [mas] más', sig.q, txtMas, true) + '</span>'
          + '<button type="button" data-subir="' + clave + '" data-cant="' + sig.q + '">'
          + texto(hueco.getAttribute('data-boton') || 'Subir', sig.q, txtMas, false) + '</button>');
      });
    },

    /* cuenta atrás de «reservamos tu oferta»: se guarda por pestaña */
    tic: null,
    reloj: function () {
      var r = this.raiz(), caja = r && qs('[data-reserva]', r);
      if (!caja) return;
      var min = parseInt(caja.getAttribute('data-minutos'), 10) || 0;
      if (!min) { caja.hidden = true; return; }
      var fin = 0;
      try {
        fin = parseInt(sessionStorage.getItem('alorah_reserva') || '0', 10);
        if (!fin || fin < Date.now()) { fin = Date.now() + min * 60000; sessionStorage.setItem('alorah_reserva', String(fin)); }
      } catch (e) { fin = Date.now() + min * 60000; }
      var reloj = qs('[data-reloj]', caja), txt = qs('[data-reserva-txt]', caja);
      caja.hidden = false;
      if (this.tic) clearInterval(this.tic);
      var pinta = function () {
        var s = Math.max(0, Math.round((fin - Date.now()) / 1000));
        if (s <= 0) {
          clearInterval(Carrito.tic); Carrito.tic = null;
          if (txt) txt.textContent = caja.getAttribute('data-fin') || '';
          if (reloj) reloj.textContent = '';
          return;
        }
        var m = Math.floor(s / 60), ss = s % 60;
        if (reloj) reloj.textContent = (m < 10 ? '0' : '') + m + ':' + (ss < 10 ? '0' : '') + ss;
      };
      pinta();
      this.tic = setInterval(pinta, 1000);
    },

    /* quita líneas del carrito comprobando que de verdad se fueron; reintenta una vez
       (el mismo patrón que «quitaViejas» de subir) */
    quitaComprobando: function (claves, intento) {
      var self = this, upd = {};
      claves.forEach(function (k) { upd[k] = 0; });
      return fetchNativo(ACTUALIZAR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Alorah': '1' },
        body: JSON.stringify({ updates: upd })
      }).then(function (r) {
        return r.json().then(function (j) {
          var quedan = (j.items || []).some(function (it) { return claves.indexOf(it.key) > -1; });
          if (!r.ok || quedan) throw new Error('quitar');
          return j;
        });
      }).catch(function (e) { if (!intento) return self.quitaComprobando(claves, 1); throw e; });
    },

    /* deja una línea en q unidades (solo lo usa unPack, para deshacer una suma de Shopify) */
    dejaEn: function (clave, q) {
      return fetchNativo(CAMBIAR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Alorah': '1' },
        body: JSON.stringify({ id: clave, quantity: q })
      }).then(function (r) { if (!r.ok) throw new Error('recortar'); });
    },

    /* UN PACK POR PRODUCTO. Si acaba de entrar un pack de un producto que ya tenía otro en el carrito (se
       volvió a pulsar comprar, o se volvió a la ficha y se eligió otro pack), el nuevo SUSTITUYE al viejo,
       con sus regalos, en vez de apilarse (caso real del 1-oct: 2 + 2 a $1,198 cuando el pack de 4 costaba $899).
       «nuevos» = ids de grupo de Kaching recién añadidos (lista vacía = lo añadido no era un pack: no se
       hace nada). Sin «nuevos» (añadido de otra app, no se sabe qué entró) manda el orden del carrito:
       Shopify pone arriba lo último que entra. Solo mira líneas con __kaching_bundles: los productos
       sueltos y la protección de envío no se tocan. No actúa mientras «Lo quiero» (subir) está trabajando.
       Dos casos que Kaching no distingue con «id» (ver grupoKaching):
         · bloque de packs sin regalos (gotas, crema, bálsamo): cada línea principal es su pack;
         · la MISMA barra sin regalo añadida dos veces (p. ej. la de 1 unidad del EyeLift): la propiedad es idéntica
           y Shopify SUMA en la misma línea (1 + 1 al precio de 1 cada una); si la línea recién añadida lleva más
           unidades que su barra, se deja en las de la barra.
       Nunca rechaza: el que la llama puede encadenar sin miedo. */
    unPack: function (nuevos, habiaPack) {
      var self = this, sabe = !!nuevos;
      if (self.subiendo || self.mirandoPacks || (sabe && !nuevos.length)) return Promise.resolve();
      self.mirandoPacks = true;                           /* cerrojo: una sola revisión a la vez */
      nuevos = nuevos || [];
      /* acaba de entrar un pack y en el carrito ya se veía otro: mientras se lee si hay que quitar el viejo, el
         carrito se atenúa (sin «Pagar» ni «Lo quiero»). Si no, durante esa lectura se ven los dos packs y se puede
         ir a pagar con los dos, o subir uno y dejar el otro apilado. Tope de 4 s: una red colgada no bloquea el carrito */
      var atenuado = !!(sabe && habiaPack), tope = null;
      if (atenuado) {
        self.ocupado(true);
        tope = setTimeout(function () { if (atenuado && !self.limpiando) { atenuado = false; if (!self.subiendo) self.ocupado(false); } }, 4000);
      }
      return fetchNativo((R.carrito || '/cart') + '.js', { headers: { 'Accept': 'application/json', 'X-Alorah': '1' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var grupos = Object.create(null), orden = [], recortes = [];   /* sin prototipo, como en marcaPacks */
          (cart.items || []).forEach(function (it) {
            var x = grupoKaching(it);                     /* null: producto suelto, protección de envío o datos viejos */
            /* sin saber qué entró (añadido de otra app) no se tocan los packs sin «id»: dos líneas podrían ser un mismo pack */
            if (!x || (!sabe && x.g.charAt(0) === '~')) return;
            if (!grupos[x.g]) { grupos[x.g] = { producto: '', claves: [] }; orden.push(x.g); }
            grupos[x.g].claves.push(it.key);
            if (!x.kb.main) return;
            grupos[x.g].producto = String(x.kb.pp || it.product_id);
            if (sabe && nuevos.indexOf(x.g) > -1) {       /* línea recién añadida con más unidades que su barra: Shopify sumó */
              var uds = unidadesDeBarra(grupos[x.g].producto, x.kb.bid || x.kb.bar);
              if (uds && it.quantity > uds) recortes.push({ clave: it.key, q: uds });
            }
          });
          /* delante, los que acaban de entrar; el resto, en el orden del carrito (arriba lo último) */
          orden = orden.filter(function (g) { return nuevos.indexOf(g) > -1; })
            .concat(orden.filter(function (g) { return nuevos.indexOf(g) === -1; }));
          var queda = Object.create(null), viejas = [];
          orden.forEach(function (g) {
            var p = grupos[g].producto;
            if (!p) return;                               /* grupo sin línea principal: no es un pack */
            if (!queda[p]) { queda[p] = g; return; }      /* el pack que se queda */
            if (sabe && nuevos.indexOf(g) > -1) return;   /* otra línea del mismo añadido (un pack con dos variantes) */
            if (sabe && nuevos.indexOf(queda[p]) === -1) return;   /* de este producto no ha entrado pack ahora */
            viejas = viejas.concat(grupos[g].claves);
          });
          if ((!viejas.length && !recortes.length) || self.subiendo) return;
          self.limpiando = true;                          /* a partir de aquí «Lo quiero» (subir) espera */
          self.ocupado(true);
          /* se repinta pidiendo el carrito de nuevo (no con la respuesta del quitar): manda el estado final
             aunque otra app haya tocado el carrito entre medias */
          var paso = viejas.length ? self.quitaComprobando(viejas, 0) : Promise.resolve();
          recortes.forEach(function (x) { paso = paso.then(function () { return self.dejaEn(x.clave, x.q); }); });
          return paso.then(function () { if (self.raiz()) return self.refresca(); });
        })
        .catch(function () {
          if (!self.limpiando || !self.raiz()) return;
          return self.refresca().then(function () { self.aviso('Revisa tu carrito: no se pudo quitar el pack anterior.'); });
        })
        .then(function () {
          self.mirandoPacks = false;
          if (tope) clearTimeout(tope);
          /* si «Lo quiero» se ha puesto a trabajar entre medias (con el teclado se alcanza un botón atenuado), el
             carrito no se suelta aquí: lo suelta él al acabar */
          if (self.limpiando || atenuado) { self.limpiando = false; atenuado = false; if (!self.subiendo) self.ocupado(false); }
        });
    },

    /* después de añadir: un pack por producto y, luego, lo de siempre (abrir el carrito o ir a la página) */
    trasAnadirLimpio: function (nuevos, habiaPack) {
      var self = this, limpia = this.unPack(nuevos, habiaPack);
      if (A.alAnadir === 'page' || A.alAnadir === 'checkout') {
        /* si lo siguiente es irse a otra página (carrito o pago), antes se termina de quitar el pack viejo; tope de 4 s */
        var ido = false, ir = function () { if (!ido) { ido = true; self.trasAnadir(); } };
        setTimeout(ir, 4000);
        return limpia.then(ir);
      }
      this.trasAnadir();
    },

    /* otra cosa (Kaching, una app) ha tocado el carrito */
    alCambiarFuera: function (tipo) {
      var self = this;
      /* sin carrito lateral (advertorial): nada que repintar; no se pide la sección para nada */
      if (!this.raiz()) { if (tipo === 'add') this.trasAnadirLimpio(); return; }
      this.refresca().then(function () {
        if (tipo === 'add') self.trasAnadirLimpio();
      });
    },

    trasAnadir: function () {
      if (A.alAnadir === 'page') { location.href = R.carrito || '/cart'; return; }
      if (A.alAnadir === 'checkout') { location.href = '/checkout'; return; }
      this.abrir();
    }
  };
  A.carrito = Carrito;

  /* ---------------- eventos del carrito ---------------- */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    var r = Carrito.raiz();

    /* abrir desde el icono de la cabecera (o cualquier enlace a /cart si hay panel) */
    var abre = t.closest('[data-abrir-carrito]');
    if (abre && r && A.alAnadir !== 'page') { ev.preventDefault(); Carrito.abrir(); return; }

    if (!r || !r.contains(t)) return;

    if (t.closest('[data-cerrar-carrito]')) { ev.preventDefault(); Carrito.cerrar(); return; }

    var b;
    if ((b = t.closest('[data-mas]'))) { Carrito.cantidad(b.getAttribute('data-mas'), (parseInt(b.getAttribute('data-q'), 10) || 1) + 1); return; }
    if ((b = t.closest('[data-menos]'))) { Carrito.cantidad(b.getAttribute('data-menos'), (parseInt(b.getAttribute('data-q'), 10) || 1) - 1); return; }
    if ((b = t.closest('[data-quitar]'))) { Carrito.quita(b.getAttribute('data-quitar').split('|')); return; }
    if ((b = t.closest('[data-anadir-var]'))) { b.setAttribute('aria-busy', 'true'); Carrito.anade(b.getAttribute('data-anadir-var'), 1); return; }
    if ((b = t.closest('[data-subir]'))) { Carrito.subir(b); return; }
    if ((b = t.closest('[data-deshacer]'))) { Carrito.deshacer(b); return; }
  });

  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t.matches || !t.matches('[data-proteccion]')) return;
    if (t.checked) Carrito.anade(t.getAttribute('data-variante'), 1);
    else Carrito.quita([t.getAttribute('data-clave')]);
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') { Carrito.cerrar(); Menu.cerrar(); return; }
    if (ev.key !== 'Tab' || !Carrito.abierto) return;
    var panel = qs('.carrito-panel', Carrito.raiz());
    if (!panel) return;
    var f = qsa('a[href], button:not(:disabled), input:not(:disabled), [tabindex]:not([tabindex="-1"])', panel)
      .filter(function (e) { return e.offsetParent !== null; });
    if (!f.length) return;
    var pri = f[0], ult = f[f.length - 1];
    if (ev.shiftKey && document.activeElement === pri) { ult.focus(); ev.preventDefault(); }
    else if (!ev.shiftKey && document.activeElement === ult) { pri.focus(); ev.preventDefault(); }
  });

  /* lo que avisa el gancho de <head> cuando alguien que no somos nosotros toca el carrito */
  document.addEventListener('alorah:carrito-externo', function (ev) {
    Carrito.alCambiarFuera(ev.detail && ev.detail.tipo);
  });

  /* ======================================================================
     FICHA: añadir al carrito sin recargar
     ====================================================================== */
  /* grupo de una línea de pack de Kaching: su «id», que comparten el pack y sus regalos. Kaching solo pone «id»
     cuando el bloque de packs tiene regalos; en un bloque sin regalos (hoy gotas, crema y bálsamo) la línea lleva
     solo «bid» (la barra): ahí cada línea principal es su propio pack y el grupo es «~» + la clave de la línea.
     null = no es un pack (producto suelto, protección de envío) o son datos viejos (solo «v»). */
  function grupoKaching(it) {
    var kb = it && it.properties && it.properties.__kaching_bundles;
    if (!kb) return null;
    try { kb = typeof kb === 'string' ? JSON.parse(kb) : kb; } catch (e) { return null; }
    if (!kb) return null;
    var g = kb.id || (kb.main && (kb.bid || kb.bar) && it.key ? '~' + it.key : '');
    return g ? { g: String(g), kb: kb } : null;
  }

  /* unidades de una barra de cantidad del pack de este producto para el mercado de la visita (se lee de los datos
     que Kaching deja en la ficha); 0 = no se sabe */
  function unidadesDeBarra(pid, barra) {
    var n = 0;
    if (!barra) return 0;
    packsDelMercado().forEach(function (p) {
      if (String(p.pid) !== String(pid)) return;
      (p.cfg.dealBars || []).forEach(function (b) {
        if (b.id === barra && (!b.dealBarType || b.dealBarType === 'quantity-break')) n = parseInt(b.quantity, 10) || 0;
      });
    });
    return n;
  }

  /* grupos de los packs de Kaching que vienen en la respuesta de /cart/add: así unPack sabe cuál es el nuevo */
  function gruposNuevos(j) {
    var ids = [];
    try {
      (j && j.items ? j.items : [j]).forEach(function (it) {
        var x = grupoKaching(it);
        if (x && ids.indexOf(x.g) === -1) ids.push(x.g);
      });
    } catch (e) {}
    return ids;
  }

  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!(f instanceof HTMLFormElement)) return;
    if (!/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (A.alAnadir === 'page' && !Carrito.raiz()) return;          /* camino normal */
    ev.preventDefault();

    /* Kaching (u otra app) ya lo añadió con este mismo clic: no duplicar */
    if (Date.now() - (window.__alorahUltimoAjeno || 0) < 2500) return;

    var boton = qs('[type="submit"], [name="add"]', f);
    var error = qs('[data-error-compra]', f.closest('[data-compra]') || f);
    if (boton) boton.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;

    var fd = new FormData(f);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', rutaPagina());
    var entro = false;                                    /* true desde que Shopify contesta que el producto YA está en el carrito */
    fetchNativo(ANADIR, { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-Alorah': '1' } })
      .then(function (r) { entro = r.ok; return r.json().then(function (j) { return { ok: r.ok, j: j, propia: delSitio(r) }; }); })
      .then(function (res) {
        if (!res.ok) {
          /* dentro del editor de temas Shopify rechaza compras que en la tienda funcionan («ya está agotado»): se avisa claro */
          var enEditor = window.Shopify && window.Shopify.designMode;
          if (error) { error.textContent = enEditor ? 'En el editor de Shopify no se puede comprar. Pruébalo en la vista previa: ahí funciona como en la tienda.' : (res.j.description || res.j.message || 'No se pudo añadir. Inténtalo otra vez.'); error.hidden = false; }
          return;
        }
        /* ¿se veía ya algún pack en el carrito? Se mira ANTES de repintar: pinta() cambia el nodo entero y las
           marcas de pack (marcaPacks) tardan una petición en volver */
        var habiaPack = !!qs('[data-linea-pack]', Carrito.raiz());
        if (res.propia && res.j.sections && res.j.sections['cart-drawer']) Carrito.pinta(res.j.sections['cart-drawer']);
        else Carrito.refresca();
        /* un pack por producto: si ya había uno de este producto, el que acaba de entrar lo sustituye */
        return Carrito.trasAnadirLimpio(gruposNuevos(res.j), habiaPack);
      })
      .catch(function () {
        /* el envío normal del formulario es la reserva para cuando la petición NO llegó. Si el producto ya entró y
           lo que ha fallado es leer la respuesta o pintar el carrito, enviarlo otra vez lo añadiría DOS veces:
           se va a la página del carrito, que lo enseña tal cual está */
        if (entro) { location.href = R.carrito || '/cart'; return; }
        f.submit();
      })
      .then(function () { if (boton) boton.removeAttribute('aria-busy'); });
  });

  /* ======================================================================
     IR A LA COMPRA (lo usan los botones de las secciones de la landing)
     ====================================================================== */
  function altoCabecera() {
    var c = qs('.cabecera-fija');
    return c ? c.getBoundingClientRect().height : 0;
  }
  function aro(btn) {
    if (!btn) return;
    var radio = parseFloat(getComputedStyle(btn).borderTopLeftRadius) || 0;
    var a = document.createElement('span');
    a.setAttribute('aria-hidden', 'true');
    a.style.cssText = 'position:fixed;pointer-events:none;z-index:2147483000;border-radius:' + (radio ? radio + 7 : 999) + 'px;'
      + 'box-shadow:0 0 0 3px rgba(219,147,183,.95),0 0 24px 8px rgba(219,147,183,.45);transition:opacity .2s linear';
    document.body.appendChild(a);
    var fin = Date.now() + 2400;
    (function sigue() {
      var r = btn.getBoundingClientRect();
      a.style.left = (r.left - 7) + 'px'; a.style.top = (r.top - 7) + 'px';
      a.style.width = (r.width + 14) + 'px'; a.style.height = (r.height + 14) + 'px';
      if (Date.now() < fin) requestAnimationFrame(sigue); else if (a.parentNode) a.parentNode.removeChild(a);
    })();
    var pasos = ['1', '0.1', '1', '0.1', '1', '0'], i = 0;
    var late = setInterval(function () { a.style.opacity = pasos[i++]; if (i >= pasos.length) clearInterval(late); }, 330);
  }
  /* marca el pack i de Kaching (solo si no lo está ya) */
  function marcaPackKaching(indicePack) {
    if (typeof indicePack !== 'number' || indicePack < 0) return;
    var radios = qsa('kaching-bundles-block input[type="radio"]');
    if (radios[indicePack] && !radios[indicePack].checked) radios[indicePack].click();
  }
  /* en una página sin compra (advertorial): el enlace a la ficha que pinta la sección, con el pack i si se pide */
  function enlaceAdvertorial(adv, indicePack) {
    var href = adv.getAttribute('data-avp-enlace') || '';
    var packs = (adv.getAttribute('data-avp-packs') || '').split(',');
    if (typeof indicePack === 'number' && packs[indicePack] && /^\d+$/.test(packs[indicePack])) {
      try {
        var u = new URL(href, location.origin);
        u.searchParams.set('pack', packs[indicePack]);
        href = u.pathname + u.search;
      } catch (e) {}
    }
    return href;
  }
  /* a dónde baja «ir a comprar»: a los packs de Kaching. Mientras la app no ha pintado, su marcador está vacío y no
     tiene caja (su hoja lleva kaching-bundle:empty{display:none}): medirlo daba 0 y la página no se movía. Vale
     entonces la caja que lo envuelve (.alh-app, justo donde nacen los packs). Sin packs, null. */
  function destinoPacks(compra) {
    var m = compra ? qs('kaching-bundle', compra) : null;
    if (m && m.getClientRects().length) return m;
    var caja = m ? m.closest('.alh-app') : null;
    return caja && caja.getClientRects().length ? caja : null;
  }
  window.alorahIrAComprar = function (indicePack) {
    var compra = qs('[data-compra]');
    if (!compra) {
      var f = qs('form[action*="/cart/add"]');
      compra = f ? f.parentElement : null;
    }
    if (!compra) {
      /* en el advertorial no hay compra: los botones de las secciones alorah-* llevan a la ficha con su pack */
      var adv = qs('[data-avp-enlace]');
      var destinoAdv = adv ? enlaceAdvertorial(adv, indicePack) : '';
      if (destinoAdv) { location.href = destinoAdv; return; }
      window.scrollTo({ top: 0, behavior: 'smooth' }); return;
    }
    marcaPackKaching(indicePack);
    var destino = destinoPacks(compra) || compra;
    var y = destino.getBoundingClientRect().top + window.pageYOffset - altoCabecera() - 18;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    var prev = null, vueltas = 0;
    var espera = setInterval(function () {
      var yy = window.pageYOffset;
      if ((prev !== null && Math.abs(yy - prev) < 1.5) || ++vueltas > 60) {
        clearInterval(espera);
        aro(qs('[data-boton-compra]', compra) || qs('[name="add"]', compra));
      }
      prev = yy;
    }, 80);
  };

  /* ---------------- ?pack=N en la ficha (viene del advertorial) ----------------
     N = unidades del pack de Kaching. El script en línea de main-product ya dejó esa barra
     elegida en el marcador de Kaching (window.__alorahPack). Aquí, cuando Kaching termina,
     se comprueba (plan B: si no quedó marcada, se marca) y, en el móvil, se baja a la compra
     con el aro, solo si la compra está por debajo de media pantalla y la clienta aún no se ha movido.
     Después se quita ?pack de la URL (replaceState). Si ninguna barra tiene esas unidades, no se hace nada. */
  function indicePackDe(n) {
    var pid = window.alorahProducto && window.alorahProducto.id;
    var packs = packsDelMercado().filter(function (p) { return !pid || String(p.pid) === String(pid); });
    if (!packs.length) return -1;
    var barras = packs[0].cfg.dealBars || [];
    for (var i = 0; i < barras.length; i++) if (parseInt(barras[i].quantity, 10) === n) return i;
    return -1;
  }
  function packDeUrl() {
    var n = 0;
    try { n = parseInt(new URLSearchParams(location.search).get('pack'), 10) || 0; } catch (e) { return; }
    if (!n || !qs('[data-compra]')) return;
    var i = window.__alorahPack ? window.__alorahPack.i : indicePackDe(n);
    if (typeof i !== 'number' || i < 0) return;
    var hecho = false, y0 = window.pageYOffset;
    function sigue() {
      if (hecho) return;
      hecho = true;
      setTimeout(function () {
        var compra = qs('[data-compra]');
        if (!compra) return;
        var destino = qs('kaching-bundle', compra) || qs('kaching-bundles-block', compra) || compra;
        var abajo = destino.getBoundingClientRect().top > window.innerHeight * 0.5;
        var quieta = Math.abs(window.pageYOffset - y0) < 60;
        /* solo en el móvil (989 = corte de main-product): en escritorio la compra ya está en la columna derecha */
        var movil = true;
        try { movil = !window.matchMedia || window.matchMedia('(max-width: 989px)').matches; } catch (e) {}
        if (abajo && quieta && movil) window.alorahIrAComprar(i);
        else marcaPackKaching(i);
        /* ?pack ya ha hecho su trabajo (Kaching arrancado y el píxel ya leyó la URL): se quita de la barra de
           direcciones para que recargar o volver desde el checkout no pise el pack que elija la clienta ni la vuelva a bajar */
        try {
          var u = new URL(location.href);
          if (u.searchParams.has('pack')) {
            u.searchParams.delete('pack');
            history.replaceState(history.state, '', u.pathname + u.search + u.hash);
          }
        } catch (e) {}
      }, 150);
    }
    if (window.kachingBundlesInitialized) sigue();
    else {
      window.addEventListener('kaching-bundles-initialized', sigue);
      setTimeout(sigue, 6000);   /* red de seguridad por si Kaching no avisa */
    }
  }

  /* ======================================================================
     CABECERA
     ====================================================================== */
  var Menu = {
    el: function () { return qs('#MenuMovil'); },
    abrir: function () {
      var m = this.el(); if (!m) return;
      m.hidden = false; document.documentElement.classList.add('bloqueo');
      requestAnimationFrame(function () { m.classList.add('abierto'); });
      var x = qs('[data-cerrar-menu]', m); if (x) x.focus({ preventScroll: true });
    },
    cerrar: function () {
      var m = this.el(); if (!m || m.hidden) return;
      m.classList.remove('abierto'); document.documentElement.classList.remove('bloqueo');
      setTimeout(function () { m.hidden = true; }, 300);
    }
  };
  document.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-abrir-menu]')) { ev.preventDefault(); Menu.abrir(); return; }
    if (ev.target.closest('[data-cerrar-menu]')) { ev.preventDefault(); Menu.cerrar(); }
  });

  function sombraCabecera() {
    var c = qs('.cab');
    if (c) c.classList.toggle('cab--sombra', window.pageYOffset > 6);
  }

  /* ======================================================================
     FICHA: galería, barra de compra fija y variantes
     ====================================================================== */
  function galerias() {
    qsa('[data-galeria]').forEach(function (g) {
      var pista = qs('[data-pista]', g);
      if (!pista || pista.__listo) return;
      pista.__listo = true;
      var minis = qsa('[data-mini]', g), puntos = qsa('[data-punto]', g);
      function marca(i) {
        minis.forEach(function (m, k) { m.classList.toggle('activa', k === i); m.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        puntos.forEach(function (p, k) { p.classList.toggle('activa', k === i); });
      }
      function ve(i) {
        var foto = pista.children[i];
        if (foto) pista.scrollTo({ left: foto.offsetLeft - pista.offsetLeft, behavior: 'smooth' });
        marca(i);
      }
      minis.forEach(function (m, i) { m.addEventListener('click', function () { ve(i); }); });
      qsa('[data-flecha]', g).forEach(function (b) {
        b.addEventListener('click', function () {
          var i = Math.round(pista.scrollLeft / pista.clientWidth) + (b.getAttribute('data-flecha') === 'sig' ? 1 : -1);
          ve(Math.max(0, Math.min(pista.children.length - 1, i)));
        });
      });
      var t = null;
      pista.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { marca(Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth))); }, 60);
      }, { passive: true });
    });
  }

  /* ---------------- reseñas cortas en carrusel (ficha) ----------------
     Las reseñas que van debajo del botón de comprar, cuando hay dos o más seguidas, se pasan con el dedo, con
     las flechas (escritorio) o solas cada 6 s. El paso solo anda mientras se ven y se para en cuanto la clienta
     toca el carrusel; con «menos movimiento» puesto en el movil no se mueve nunca solo. */
  function carruselResenas() {
    qsa('[data-rcs]').forEach(function (caja) {
      var pista = qs('[data-rcs-pista]', caja);
      if (!pista || pista.__listo) return;
      pista.__listo = true;
      var puntos = qsa('[data-rc-punto]', caja);
      var cuantas = pista.children.length;
      if (cuantas < 2) return;
      var reloj = null, suelta = false, i = 0;
      var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function marca(k) {
        i = k;
        puntos.forEach(function (p, j) { p.classList.toggle('activa', j === k); });
      }
      function ve(k) {
        k = (k + cuantas) % cuantas;
        var hijo = pista.children[k];
        if (hijo) pista.scrollTo({ left: hijo.offsetLeft - pista.offsetLeft, behavior: quieto ? 'auto' : 'smooth' });
        marca(k);
      }
      function para() { clearInterval(reloj); reloj = null; }
      function anda() {
        if (reloj || suelta || quieto) return;
        reloj = setInterval(function () { ve(i + 1); }, 6000);
      }
      function basta() { suelta = true; para(); }

      qsa('[data-rcs-flecha]', caja).forEach(function (b) {
        b.addEventListener('click', function () { basta(); ve(i + (b.getAttribute('data-rcs-flecha') === 'sig' ? 1 : -1)); });
      });
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
        pista.addEventListener(ev, basta, { passive: true });
      });
      caja.addEventListener('mouseenter', para);
      caja.addEventListener('mouseleave', anda);

      /* la tarjeta que mas cerca queda del borde izquierdo: contar por anchos se desviaria con el hueco entre tarjetas */
      function cual() {
        var mejor = 0, dist = Infinity;
        for (var k = 0; k < cuantas; k++) {
          var d = Math.abs(pista.children[k].offsetLeft - pista.offsetLeft - pista.scrollLeft);
          if (d < dist) { dist = d; mejor = k; }
        }
        return mejor;
      }
      var t = null;
      pista.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { marca(cual()); }, 60);
      }, { passive: true });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { if (e[0].isIntersecting) anda(); else para(); }, { threshold: .4 }).observe(caja);
      } else {
        anda();
      }
    });
  }

  function barraCompra() {
    var barra = qs('[data-barra-compra]'), compra = qs('[data-boton-compra]');
    if (!barra || !compra || !('IntersectionObserver' in window)) return;
    if (barra.hasAttribute('data-desde-llegada')) { barraDesdeLlegada(barra, compra); return; }   /* casilla de la ficha: va aparte */
    var visto = false;
    new IntersectionObserver(function (e) {
      var fuera = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      barra.classList.toggle('visible', fuera);
      if (!visto && fuera) visto = true;
    }, { threshold: 0 }).observe(compra);
    qsa('[data-ir-compra]', barra).forEach(function (b) {
      b.addEventListener('click', function (ev) { ev.preventDefault(); window.alorahIrAComprar(); });
    });
  }

  /* ---------------- barra de compra «desde la llegada» ----------------
     Casilla «Barra a la vista desde que llega la visita» de la ficha (main-product pone data-desde-llegada en la
     barra). La barra se ve desde el primer momento y se esconde SOLO mientras la compra de verdad —el bloque de
     packs (el .alh-app que lleva el marcador de Kaching) o el botón de comprar— asoma por ENCIMA de ella. Al pasar
     de largo, hacia abajo o hacia arriba, vuelve a salir. En una ficha sin packs cuenta solo el botón.
     «Por encima de ella»: la pantalla se mide sin la franja de abajo que ocupa la barra (rootMargin). Lo que solo
     asoma por detrás de la barra no la esconde: así no se va al llegar en una pantalla alta, ni parpadea cuando
     Kaching pinta los packs y empuja el botón hacia abajo (los packs nacen justo donde estaba el botón).
     Al llegar, en el móvil, la enseña el trozo en línea de main-product, sin esperar a este fichero; aquí solo se
     pone o se quita «visible», y con eso vigilaBarraAbajo sube o baja la pestaña de Klaviyo como siempre.
     El botón de la barra no se engancha aquí: en este modo trae su propio onclick, que vale desde que se pinta. */
  function barraDesdeLlegada(barra, compra) {
    var marcador = qs('kaching-bundle', compra.closest('[data-compra]') || document);
    var packs = marcador ? marcador.closest('.alh-app') || marcador : null;
    var asoman = [];                                     /* de los dos (botón y packs), los que se ven ahora mismo */
    var ojo = new IntersectionObserver(function (e) {
      e.forEach(function (x) {
        var i = asoman.indexOf(x.target);
        if (x.isIntersecting && i === -1) asoman.push(x.target);
        else if (!x.isIntersecting && i > -1) asoman.splice(i, 1);
      });
      barra.classList.toggle('visible', !asoman.length);
    }, { threshold: 0, rootMargin: '0px 0px -' + barra.offsetHeight + 'px 0px' });
    ojo.observe(compra);
    if (packs) ojo.observe(packs);
  }

  /* ---------------- hueco de la barra fija de abajo ----------------
     La pestaña de Klaviyo («LLÉVATE UN 10%…») es un <div> fijo, con bottom:0 y z-index 90000, que Klaviyo
     cuelga de <body>: cae justo encima de la barra fija de compra y se lleva sus toques. Klaviyo no se toca.
     Aquí solo se mide la barra de abajo que esté a la vista —la de la ficha (.barra-compra.visible), la del
     advertorial nuevo (.avp-barra--on) o la del antiguo (.adv-fija, solo en el móvil)— y se deja en <html>
     la clase «con-barra-abajo» y la variable --barra-abajo con su alto en px. Con eso base.css sube la
     pestaña (y el botón de WhatsApp). Sin barra a la vista se quitan las dos cosas y todo queda como siempre. */
  function barraAbajo() {
    var raiz = document.documentElement, alto = 0;
    qsa('.barra-compra.visible, .avp-barra--on, .adv-fija').forEach(function (b) {
      /* offsetHeight: el alto de la caja aunque todavía esté subiendo (transform); 0 si no se pinta (display:none) */
      if (b.offsetHeight > alto) alto = b.offsetHeight;
    });
    if (alto) {
      raiz.classList.add('con-barra-abajo');
      raiz.style.setProperty('--barra-abajo', alto + 'px');
    } else {
      raiz.classList.remove('con-barra-abajo');
      raiz.style.removeProperty('--barra-abajo');
    }
  }
  /* se mide al arrancar y cada vez que cambia la clase de una de esas barras (cuando aparece o se esconde) */
  function vigilaBarraAbajo() {
    barraAbajo();
    if (!window.MutationObserver) return;
    qsa('[data-barra-compra], [data-avp-barra], .adv-fija').forEach(function (b) {
      if (b.__alorahVigilada) return;
      b.__alorahVigilada = true;
      new MutationObserver(barraAbajo).observe(b, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function variantes() {
    qsa('[data-variantes]').forEach(function (caja) {
      var datos = qs('script[data-variantes-json]', caja);
      if (!datos) return;
      var lista = JSON.parse(datos.textContent || '[]');
      var form = document.getElementById(caja.getAttribute('data-form'));
      caja.addEventListener('change', function () {
        var elegidas = qsa('input:checked, select', caja).map(function (i) { return i.value; });
        var v = lista.filter(function (x) {
          return x.options.every(function (o, k) { return o === elegidas[k]; });
        })[0];
        if (!v || !form) return;
        var id = qs('input[name="id"]', form); if (id) id.value = v.id;
        var boton = qs('[data-boton-compra]', form);
        if (boton) { boton.disabled = !v.available; }
        qsa('[data-precio-variante]').forEach(function (p) { p.innerHTML = '<b>' + dinero(v.price) + '</b>' + (v.compare_at_price > v.price ? ' <s>' + dinero(v.compare_at_price) + '</s>' : ''); });
        var url = new URL(location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      });
    });
  }

  /* ======================================================================
     APARECER AL BAJAR (secciones nuevas: home, etc.)
     ====================================================================== */
  function aparecer() {
    var els = qsa('.rev:not(.rev-on)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || document.documentElement.classList.contains('sin-anim')) {
      els.forEach(function (e) { e.classList.add('rev-on'); }); return;
    }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('rev-on'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () { els.forEach(function (e) { e.classList.add('rev-on'); }); }, 4500);
  }

  /* ---------------- arranque ---------------- */
  /* ---------------- fotos por mercado ----------------
     En el mercado de Estados Unidos, las fotos que llevan el precio en pesos pintado tienen su gemela en
     dólares (window.alorah.fotos, de theme.liquid). Lo que pinta el servidor ya llega cambiado; aquí se
     cambia lo que entra después por JS (carrito lateral, recomendados). En México no hay lista y no hace nada. */
  function fotosDelMercado() {
    var lista = window.alorah && window.alorah.fotos;
    if (!lista || !lista.length || !window.MutationObserver) return;
    var ATRIBUTOS = ['src', 'srcset', 'data-src', 'data-srcset'];
    function cambia(el) {
      ATRIBUTOS.forEach(function (a) {
        var v = el.getAttribute && el.getAttribute(a);
        if (!v) return;
        var n = v;
        lista.forEach(function (par) { if (n.indexOf(par[0]) !== -1) n = n.split(par[0]).join(par[1]); });
        if (n !== v) el.setAttribute(a, n);
      });
    }
    function repasa(nodo) {
      if (!nodo || nodo.nodeType !== 1) return;
      if (nodo.tagName === 'IMG' || nodo.tagName === 'SOURCE') cambia(nodo);
      qsa('img, source', nodo).forEach(cambia);
    }
    new MutationObserver(function (cambios) {
      cambios.forEach(function (c) { [].forEach.call(c.addedNodes || [], repasa); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function arranca() {
    fotosDelMercado();
    recuerdaTramos();
    pintaEntrega(document);
    galerias();
    carruselResenas();
    barraCompra();
    try { vigilaBarraAbajo(); } catch (e) { /* subir la pestaña de Klaviyo es un adorno: si falla, la ficha arranca igual */ }
    variantes();
    aparecer();
    sombraCabecera();
    Carrito.marcaPacks();
    packDeUrl();
    /* toque guardado por el trozo de <head> (theme.liquid) mientras global.js no había cargado. Se repite entero
       (baja a la compra, marca el pack, aro) solo si es reciente y la clienta sigue donde la dejó el trozo, o si
       el trozo no pudo bajarla (zona de compra aún sin pintar, advertorial). Si ya se ha ido a otra parte de la
       página, o el toque es viejo, solo se marca el pack: no se mueve la página a traición */
    var pend = window.__alorahIrPendiente;
    window.__alorahIrPendiente = null;
    if (pend) {
      var zonaPend = qs('[data-compra]');
      var cajaPend = zonaPend ? (destinoPacks(zonaPend) || qs('[data-boton-compra]', zonaPend) || zonaPend).getBoundingClientRect() : null;
      var aLaVista = !!cajaPend && cajaPend.bottom > 0 && cajaPend.top < window.innerHeight;
      var hace = Date.now() - pend.t;
      if (hace < 10000 && (!pend.bajo || aLaVista || hace < 1500)) window.alorahIrAComprar(pend.i);
      else marcaPackKaching(pend.i);
    }
    window.addEventListener('scroll', sombraCabecera, { passive: true });
    /* al cambiar el tamaño de la ventana (girar el móvil) la barra de abajo puede cambiar de alto o dejar de verse */
    var relojBarra = null;
    window.addEventListener('resize', function () { clearTimeout(relojBarra); relojBarra = setTimeout(barraAbajo, 120); });
    /* si el editor de temas vuelve a pintar una sección, la reenganchamos */
    document.addEventListener('shopify:section:load', function (e) {
      galerias(); carruselResenas(); barraCompra(); vigilaBarraAbajo(); variantes(); aparecer(); pintaEntrega(document);
      /* el carrito lateral recién repintado nace cerrado: si se estaba editando, se vuelve a abrir */
      if (e.target && e.target.querySelector && e.target.querySelector('#CarritoLateral')) { Carrito.abierto = false; Carrito.abrir(); }
    });
    /* en el editor de temas: al elegir «Carrito lateral» se abre para verlo mientras se edita, y se cierra al salir */
    document.addEventListener('shopify:section:select', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('#CarritoLateral')) Carrito.abrir();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('#CarritoLateral')) Carrito.cerrar();
    });
    /* si al volver atrás el navegador sirve la página de caché, el carrito puede estar viejo */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      /* página servida de caché: si una revisión de packs (unPack) quedó a medias al irse, sus cerrojos no deben quedarse echados */
      Carrito.mirandoPacks = false; Carrito.limpiando = false;
      if (Carrito.raiz()) Carrito.refresca();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca);
  else arranca();
})();
